<template>
  <v-main app>
    <v-navigation-drawer
      clipped
      app
      fixed
      :permanent="$vuetify.breakpoint.mdAndUp"
      v-model="drawer"
      style="z-index: 1"
    >
      <v-container class="sidebar" fluid>
        <v-list>
          <v-list-item>
            <v-btn
              class="d-flex justify-start"
              width="100%"
              :exact-path="true"
              outlined
              color="primary"
              to="/customer/marketing/overview"
            >
              <v-icon class="mr-4"> mdi-text-long </v-icon>
              Overview
            </v-btn>
          </v-list-item>
          <v-list-item>
            <v-btn
              class="d-flex justify-start"
              width="100%"
              :exact-path="true"
              outlined
              color="primary"
              to="/customer/marketing/images"
            >
              <v-icon class="mr-4"> mdi-image-multiple-outline </v-icon>
              Images
            </v-btn>
          </v-list-item>
        </v-list>
      </v-container>
    </v-navigation-drawer>
    <v-container fluid>
      <router-view />
    </v-container>
  </v-main>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
    };
  },
  computed: {},
  async created() {},
};
</script>
<style lang="scss" scoped>
.theme--light.v-btn-active::before.v-btn-active:hover::before {
  cursor: text !important;
}
</style>
